import $ from "jquery";

$(function () {
  $(".archive-select").change(function () {
    const url = $(this).val() as string;
    document.location = `${url}`;
  });
});
